import React, { Component } from "react";
import spainFlag from "../../assets/images/spain-flag.png";
import pakistanFlag from "../../assets/images/pakistan-flag.png";
import ukFlag from "../../assets/images/uk-flag.png";
import uaeFlag from "../../assets/images/uae-flag.png";

const Flags = ({ heading }) => {
  let enabledLanguages = window["app-config"].enabledLanguages;

  let setLanguageOnFlagClick = (language) => {
    let url = window.location.href;
    let index = url.indexOf("lang=");
    let selectedLang = index !== -1 ? url.substring(index, index + 7) : "";
    if (url.includes("?lang=")) {
      url = url.replace(`?${selectedLang}`, `?lang=${language}`);
    } else if (url.includes("&lang=")) {
      url = url.replace(`&${selectedLang}`, `&lang=${language}`);
    } else {
      if (url.split("?")[1] !== undefined) {
        url += `&lang=${language}`;
      } else {
        url += `?lang=${language}`;
      }
    }
    window.location.href = url;
    localStorage.setItem("lang", language);
  };

  return (
    <>
      {enabledLanguages.english === true ||
      enabledLanguages.arabic === true ||
      enabledLanguages.urdu === true ||
      enabledLanguages.spanish === true ? (
        <h3
          className="select-lang"
          style={{
            marginTop: "-70px",
            float: "right",
            position: "relative",
            fontWeight: "bold",
            marginRight: "20px",
            
          }}
        >
          {heading}
        </h3>
      ) : null}

      <div
        className="flags"
        style={{
          display: "flex",
          flexDirection: "row",
          float: "right",
          marginTop: "15px",
        }}
      >
        {enabledLanguages.spanish === true ? (
          <div onClick={() => setLanguageOnFlagClick("es")} id="es">
            <img
              className="flag"
              src={spainFlag}
              style={{
                float: "left",
                height: "35px",
                width: "55px",
                marginTop: "-60px",
                cursor: "pointer",
              }}
            />
          </div>
        ) : null}
        &nbsp;&nbsp;
        {enabledLanguages.english === true ? (
          <div onClick={() => setLanguageOnFlagClick("en")} id="en">
            <img
              className="flag"
              src={ukFlag}
              style={{
                float: "left",
                height: "35px",
                width: "55px",
                marginTop: "-60px",
                cursor: "pointer",
              }}
            />
          </div>
        ) : null}
        &nbsp;&nbsp;
        {enabledLanguages.urdu === true ? (
          <div onClick={() => setLanguageOnFlagClick("ur")} id="ur">
            <img
              className="flag"
              src={pakistanFlag}
              style={{
                float: "left",
                height: "35px",
                width: "55px",
                marginTop: "-60px",
                cursor: "pointer",
              }}
            />
          </div>
        ) : null}
        &nbsp;&nbsp;
        {enabledLanguages.arabic === true ? (
          <div onClick={() => setLanguageOnFlagClick("ar")} id="ar">
            <img
              className="flag"
              src={uaeFlag}
              style={{
                float: "left",
                height: "35px",
                width: "55px",
                marginTop: "-60px",
                cursor: "pointer",
              }}
            />
          </div>
        ) : null}
      </div>
    </>
  );
};

export default Flags;
